import { callAPI } from '../../../../services/api.service';

export interface FileMigrationResponse {
  status: number;
  message: string;
  data?: any;
}

export const startFileMigration = async (): Promise<FileMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/migrate-files', {}, 'POST');
    return response;
  } catch (error: any) {
    console.error('Failed to start file migration:', error);
    throw error;
  }
};

export const getFileMigrationStatus = async (): Promise<FileMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/file-migration-status');
    return response;
  } catch (error: any) {
    console.error('Failed to get file migration status:', error);
    throw error;
  }
};

export const resetFileMigration = async (): Promise<FileMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/reset-file-migration', {}, 'POST');
    return response;
  } catch (error: any) {
    console.error('Failed to reset file migration:', error);
    throw error;
  }
};
